import type { ReactNode, RefObject } from "react";

interface AutocompleteListProps {
  listRef: RefObject<HTMLUListElement>;
  children: ReactNode;
  footer?: ReactNode;
}

const AutocompleteList = ({ listRef, children, footer }: AutocompleteListProps) => (
  <div className="absolute left-0 right-0 top-full z-50 mt-2 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_16px_40px_rgba(15,23,42,0.14)] duration-200 animate-in fade-in-0 zoom-in-95 slide-in-from-top-2">
    <ul ref={listRef} role="listbox" className="max-h-72 overflow-auto py-2">
      {children}
    </ul>
    {footer}
  </div>
);

export default AutocompleteList;
